import React from 'react'
import { useContext } from 'react'
import { LangCtx } from '../../lib/context'
import "../../ui-styles/pageCenter/pageCenter.css"

const SiteNoteReached = () => {
    const { l } = useContext(LangCtx);
  return (
    <div className="pageCntr">
                <div className="pageCntBlock pdngMD">
                    <div className="pcIconBox">
                        <img src="/images/icons/notreached.png" alt="Error" />
                    </div>
                    <div className="pageCntHdng">
                        <h3 className='txtCenter'>{l.this_site_cannot_reached}</h3>
                    </div>
                        <div className="flexCol alignCenter justifyCenter pdngMD">
                            {/* <ul>
                                <li>{language.instavc_site_webaddress}</li>
                                <li>{language.instavc_check_internet}</li>
                                <li>{language.instavc_search_url}</li>
                                <li>{language.instavc_goto} <a href="https://app.instavc.com/">https://app.instavc.com/</a></li>
                            </ul> */}
                            <ul>
                                <li className='mrgBtm8'> <span className='blackInactiveTxt'>{l.instavc_site_webaddress} </span></li>
                                <li className='mrgBtm8'> <span className='blackInactiveTxt'>{l.instavc_check_internet}</span></li>
                                <li className='mrgBtm8'><span className='blackInactiveTxt'>{l.instavc_search_url}</span></li>
                      <li className='mrgBtm8'> <span className='blackInactiveTxt'>{l.instavc_goto}<a href={process.env.REACT_APP_appURL} rel="noopener noreferrer"> {process.env.REACT_APP_appURL}</a> </span></li>
                            </ul>
                        </div>
                    
                </div>
            </div>
  )
}

export default SiteNoteReached